import { restClient } from '@/Core'

import { toShareRow } from '../Helpers/diskResponse'

import type { DiskShareRow } from '../Contracts/DiskShare'

/**
 * Прибрати доступ: `DELETE /services/disk/shares/{uuid}` — бек віддає прибраний
 * рядок (для «Скасувати»).
 *
 * ⚠️ Ядровий `restClient.delete` віддає **сирий** `Response` (`isOriginalResponse`),
 * а не розібраний JSON, як `get`/`post`/`patch`: тіло читаємо самі. Без цього
 * рядок розбирався з порожнього об'єкта, і «Скасувати» надавав доступ «Усій
 * компанії» (вид адресата за замовчуванням).
 */
export const RemoveDiskShareTask = async (uuid: string): Promise<DiskShareRow> => {
    const response = (await restClient.delete(`/services/disk/shares/${encodeURIComponent(uuid)}`)) as unknown
    const body =
        response !== null && typeof response === 'object' && typeof (response as Response).json === 'function'
            ? ((await (response as Response).json()) as unknown)
            : response

    return toShareRow(body)
}
